module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card__status_wrapper"
  }, [(!_vm.items.activity_id && !_vm.items.isRequest) ? _c('p', {
    staticClass: "card__status",
    class: _vm.statusColorClass
  }, [_vm._v("Статус заявки на обучение: "), _c('b', [_vm._v(_vm._s(_vm.items.status))])]) : _vm._e(), (_vm.items.activity_id) ? _c('p', {
    staticClass: "card__status",
    class: _vm.statusColorClass
  }, [_vm._v("Статус заявки на мероприятие: "), _c('b', [_vm._v(_vm._s(_vm.items.status))])]) : _vm._e(), (_vm.items.isRequest) ? _c('p', {
    staticClass: "card__status",
    class: _vm.statusColorClass
  }, [_vm._v("Статус заявки на разработку: "), _c('b', [_vm._v(_vm._s(_vm.items.status))])]) : _vm._e(), _c('p', {
    staticClass: "show_hide",
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("Скрыть")])]), _c('div', {
    staticClass: "card__body"
  }, [_c('Picture', {
    staticClass: "card__image",
    attrs: {
      "copp": true,
      "src": _vm.items.img && _vm.items.img.small,
      "alt": _vm.items.title
    }
  }), (!_vm.items.isRequest) ? _c('h3', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.items.title))]) : _vm._e(), (_vm.items.isRequest) ? _c('h3', {
    staticClass: "card__title"
  }, [_vm._v("Заявка на разработку программы")]) : _vm._e(), _c('div', {
    staticClass: "card__text"
  }, [(_vm.items.date) ? _c('p', {
    staticClass: "card__data"
  }, [_vm._v("Заявка оформлена: "), _c('b', [_vm._v(_vm._s(_vm.items.date))])]) : _vm._e(), (_vm.items.schedule_dates) ? _c('p', {
    staticClass: "card__data"
  }, [_vm._v("Период обучения: "), _c('b', [_vm._v(_vm._s(_vm.items.schedule_dates.from) + " - " + _vm._s(_vm.items.schedule_dates.to))])]) : _vm._e(), (_vm.items.fio) ? _c('p', {
    staticClass: "card__data"
  }, [_vm._v("Обучающийся "), _c('b', [_vm._v(_vm._s(_vm.items.fio))])]) : _vm._e(), (_vm.items.status === "Обучается" || _vm.items.status === "Подтверждена") ? _c('p', {
    staticClass: "card__data"
  }, [_vm._v("Группа "), _c('b', [_vm._v(_vm._s(_vm.items.groupName))])]) : _vm._e(), (_vm.items.orderId) ? _c('p', {
    staticClass: "card__data"
  }, [_vm._v("Номер заявки: "), _c('b', [_vm._v(_vm._s(_vm.items.orderId))])]) : _vm._e(), (_vm.items.comment_for_client && !_vm.isOpenComment) ? _c('p', {
    staticClass: "card__data"
  }, [_c('span', {
    staticClass: "comment_open",
    on: {
      "click": function($event) {
        _vm.isOpenComment = !_vm.isOpenComment
      }
    }
  }, [_vm._v("Подробнее")])]) : _vm._e(), (_vm.isOpenComment) ? _c('p', {
    staticClass: "card__data"
  }, [_c('span', [_vm._v("Комментарий: ")]), _c('b', [_vm._v(_vm._s(_vm.items.comment_for_client))])]) : _vm._e(), (_vm.items.comment_for_client && _vm.isOpenComment) ? _c('p', {
    staticClass: "card__data"
  }, [_c('span', {
    staticClass: "comment_open",
    on: {
      "click": function($event) {
        _vm.isOpenComment = !_vm.isOpenComment
      }
    }
  }, [_vm._v("Свернуть")])]) : _vm._e()]), (_vm.items.message) ? _c('Message', {
    staticClass: "card__message",
    attrs: {
      "color": _vm.items.variant && _vm.items.variant
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.items.message))])]) : _vm._e(), _c('div', {
    staticClass: "card__controls"
  }, [(_vm.items.userCanCancel) ? _c('Cancellation', {
    on: {
      "cancel": function($event) {
        return _vm.$emit("cancel")
      }
    }
  }) : _vm._e(), (_vm.items.id) ? _c('router-link', {
    staticClass: "card__link",
    attrs: {
      "to": _vm.parse(_vm.items)
    }
  }, [_vm._v("Открыть страницу программы")]) : _vm._e(), (_vm.items.activity_id) ? _c('router-link', {
    staticClass: "card__link",
    attrs: {
      "to": _vm.routerActivity(_vm.items)
    }
  }, [_vm._v("Открыть страницу мероприятия")]) : _vm._e(), (_vm.items.isRequest) ? _c('router-link', {
    staticClass: "card__link",
    attrs: {
      "to": _vm.routerRequest(_vm.items)
    }
  }, [_vm._v("Подробнее")]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cf269d0","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/purchases/Purchases.vue
// module id = 391f69c53d7415aa879f
// module chunks = 89